import React from "react";
import { Heading } from "../../Heading";
import { ImgV2 } from "../../ImgV2";
export const OtherCard = ({ imgUrl, subTitle, title, cardBackground, contentTextColor, imageAlt }) => (React.createElement("div", { className: "other-card_root", style: { backgroundColor: cardBackground || "#FFF", borderColor: cardBackground || "#FFF" } },
    React.createElement(ImgV2, { src: imgUrl, alt: imageAlt }),
    React.createElement(Heading, { design: "h5-bold" }, title),
    React.createElement("div", { className: "p-regular", dangerouslySetInnerHTML: {
            __html: subTitle || "",
        }, style: { "--content-text-color": `${contentTextColor}` } })));
